(async () => {
    const productSearchContainer = document.querySelector(
        '[data-product-search]',
    );

    if (productSearchContainer) {
        await import('/components/product-search/product-search-lazy');
    }
})();
